const { debounce } = window.BAO.Utils
const { useInitialised } = window.BAO.Carousel.plugins

class TextAndMediaColumnsCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.debouncedHandleResize = debounce(this.handleResize.bind(this), 250)
    
    if (this.dataset.textAndMediaColumnsCarouselEl === 'mobile-layout-carousel' && window.BAO.MediaBreakpoints.isXsViewport) {
      this.carousel = this.setupCarousel()
    }

    this.setupListeners()
  }

  setupListeners () {
    window.addEventListener('resize', this.debouncedHandleResize)
  }

  disconnectedCallback () {
    window.removeEventListener('resize', this.debouncedHandleResize)
    super.disconnectedCallback?.()
  }

  handleResize () {
    if (this.dataset.textAndMediaColumnsCarouselEl === 'mobile-layout-carousel' && window.BAO.MediaBreakpoints.isXsViewport) {
      if (this.carousel) {
        this.carousel.destroy()
      }
      this.carousel = this.setupCarousel()
    } else {
      if (this.carousel) {
        this.carousel.destroy()
      }
      
      this.carousel = null
    }
  }

  setupCarousel () {
    if (! window.BAO.MediaBreakpoints.isXsViewport) return
    
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.25,
          spacing: 30,
        }
      },
      [
        useInitialised()
      ],
    )
  }
}

if (!customElements.get('text-and-media-columns-carousel')) {
  customElements.define('text-and-media-columns-carousel', TextAndMediaColumnsCarousel)
}
